import { useState } from 'react'
import { useComments, useDeleteComment, useToggleReaction } from '../../api/useComments'
import { Skeleton } from '../ui/Skeleton'
import CommentItem from './CommentItem'
import CommentForm from './CommentForm'
import Pagination from '../ui/Pagination'
import toast from 'react-hot-toast'

export default function CommentList({ mangaId }) {
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState('new')
  const { data, isLoading } = useComments(mangaId, page, sort)
  const { mutate: deleteComment } = useDeleteComment()
  const { mutate: toggleReaction } = useToggleReaction(mangaId)
  const [replyingTo, setReplyingTo] = useState(null)

  const comments = data?.items ?? []
  const total = data?.total ?? 0
  const pages = data?.pages ?? 1

  const handleDelete = (id) => {
    deleteComment(id, {
      onSuccess: () => toast.success('Комментарий удалён'),
      onError: () => toast.error('Не удалось удалить комментарий'),
    })
  }

  const topLevel = comments.filter((c) => !c.parent_id)
  const replies = comments.filter((c) => c.parent_id)
  const repliesFor = (id) => replies.filter((c) => c.parent_id === id)

  const handleSortToggle = () => {
    setSort((s) => s === 'new' ? 'old' : 'new')
    setPage(1)
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold">
          Комментарии{' '}
          {total > 0 && <span className="text-base font-normal text-muted">({total})</span>}
        </h2>
        {total > 1 && (
          <button
            onClick={handleSortToggle}
            className="text-sm text-muted hover:text-fg transition-colors"
          >
            {sort === 'new' ? '↓ Новые' : '↑ Старые'}
          </button>
        )}
      </div>

      <CommentForm mangaId={mangaId} />

      {isLoading ? (
        <div className="flex flex-col gap-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex gap-3 p-4 rounded-xl bg-surface">
              <Skeleton className="w-9 h-9 rounded-full shrink-0" />
              <div className="flex-1 flex flex-col gap-2">
                <Skeleton className="h-3 w-1/4 rounded" />
                <Skeleton className="h-4 w-full rounded" />
                <Skeleton className="h-4 w-3/4 rounded" />
              </div>
            </div>
          ))}
        </div>
      ) : comments.length === 0 ? (
        <p className="text-sm text-center py-8 text-muted">Комментариев пока нет. Будьте первым!</p>
      ) : (
        <>
          <div className="flex flex-col gap-2">
            {topLevel.map((comment) => (
              <div key={comment.id} className="flex flex-col gap-1.5">
                <CommentItem
                  comment={comment}
                  onDelete={handleDelete}
                  onReact={(id, type) => toggleReaction({ commentId: id, type })}
                  onReply={setReplyingTo}
                />
                {repliesFor(comment.id).map((reply) => (
                  <div key={reply.id} className="ml-10">
                    <CommentItem
                      comment={reply}
                      onDelete={handleDelete}
                      onReact={(id, type) => toggleReaction({ commentId: id, type })}
                      isReply
                    />
                  </div>
                ))}
                {replyingTo === comment.id && (
                  <div className="ml-10">
                    <CommentForm mangaId={mangaId} parentId={comment.id} onCancel={() => setReplyingTo(null)} />
                  </div>
                )}
              </div>
            ))}
          </div>

          <Pagination page={page} total={pages} onChange={setPage} className="mt-2" />
        </>
      )}
    </div>
  )
}
